import { faAt, faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { FC } from "react";
import { toast } from "react-toastify";

interface IProps {
  email: string;
  className?: string;
}

/**
 * An email address with a mailto trigger and a copy button, kept as two
 * separate controls flanking the address itself — same reasoning as
 * PhoneCallLink: wrapping the whole address in the clickable element makes
 * it unselectable, so the address stays plain selectable text. A plain <a>,
 * not react-router's Link, since Link's `to` isn't meant for a `mailto:`
 * scheme (mirrors PhoneCallLink's tel: reasoning).
 */
const EmailLink: FC<IProps> = ({ email, className }) => {
  const onCopy = () => {
    navigator.clipboard.writeText(email).then(
      () => toast.success("Email copié"),
      () => toast.error("Impossible de copier l'email")
    );
  };

  return (
    <span
      className={classNames(
        "d-inline-flex align-items-center gap-1",
        className ?? "fs--1"
      )}
    >
      <a
        href={`mailto:${email}`}
        className="text-body-secondary"
        aria-label={`Envoyer un email à ${email}`}
        title="Envoyer un email"
      >
        <FontAwesomeIcon icon={faAt} transform="shrink-3" />
      </a>
      <span className="user-select-all lb-anywhere">{email}</span>
      <button
        type="button"
        className="btn btn-link p-0 text-body-tertiary"
        aria-label={`Copier l'email ${email}`}
        title="Copier l'email"
        onClick={onCopy}
      >
        <FontAwesomeIcon icon={faCopy} transform="shrink-4" />
      </button>
    </span>
  );
};

export default EmailLink;
